import {RailsPdtConstants} from './RailsPdtConstants';
import RailsPdtLandingEvent from '../PdtModel/PdtEvents/RailsPdtLandingEvent';
import {pushPdtData} from '../PdtAnalytics';


export default class RailsPdtLandingHelper {
  static trackPageLoad(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.LOAD_PAGE;
      const pdtObject = new RailsPdtLandingEvent(pdtData).trackLandingEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackPageExit(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.EXIT_PAGE;
      const pdtObject = new RailsPdtLandingEvent(pdtData).trackLandingEvent();
      pushPdtData(pdtObject);
    } catch(e) {
      // ignore
    }
  }

  static trackBackPressed(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.BaseEventAction.CLICK_BACK;
      const pdtObject = new RailsPdtLandingEvent(pdtData).trackLandingEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }

  static trackSearchClicked(data) {
    try {
      const pdtData = data;
      pdtData.activityName = RailsPdtConstants.LandingEventAction.CLICK_SEARCH;
      const pdtObject = new RailsPdtLandingEvent(pdtData).trackLandingEvent();
      pushPdtData(pdtObject);
    } catch (e) {
      // ignore
    }
  }
}
